import React, { useEffect, useState } from "react"
import Header from "components/Header/Header"
import { Grid, Box, Typography } from "@mui/material"
import AppTextField from "components/StyledComponents/AppTextField"
import { useDispatch, useSelector } from "react-redux"
import { getAvataarPromptAction, updateAvataarPromptAction } from "redux/superAdmin/actions/user"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import AppButton from "components/StyledComponents/AppButton"
import { useHistory } from "react-router-dom"
import ToggleSwitch from "components/StyledComponents/ToggleSwitch"

const AvataarPromptManagement = () => {
  const dispatch = useDispatch()
  const [breadCrumbs, setBreadCrumbs] = useState([])
  const history = useHistory()
  const { avataarPrompt, avataarEnabled } = useSelector((store) => store?.superAdmin || {})
  const [firstPrompt, setFirstPrompt] = useState("")
  const [secondPrompt, setSecondPrompt] = useState("")
  const [isEnabled, setIsEnabled] = useState(true)

  useEffect(() => {
    dispatch(getAvataarPromptAction())
    setBreadCrumbs(createBreadcrumbs())
    document.title = "Avatar Prompt Management"
  }, [])

  useEffect(() => {
    if (avataarPrompt) {
      setFirstPrompt(avataarPrompt[0])
      setSecondPrompt(avataarPrompt[1])
    }
    if (avataarEnabled !== undefined) {
      setIsEnabled(avataarEnabled)
    }
  }, [avataarPrompt, avataarEnabled])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Header title="Avatar Prompt Management" breadCrumbs={breadCrumbs} />
      </Grid>
      <Grid item xs={12} className="d-flex align-items-center justify-content-end">
        <Box className="d-flex align-items-center">
          <Typography variant="body1" sx={{ mr: 2 }}>
            Avatar Status:
          </Typography>
          <ToggleSwitch checked={isEnabled} onChange={(e) => setIsEnabled(e.target.checked)} />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <AppTextField
          label="Prompt 1"
          isUpperCase={true}
          fullWidth
          value={firstPrompt || ""}
          onChange={(e) => setFirstPrompt(e.target.value)}
          multiline
          rows={3}
        />
      </Grid>
      <Grid item xs={12}>
        <AppTextField
          label="Prompt 2"
          isUpperCase={true}
          fullWidth
          value={secondPrompt || ""}
          onChange={(e) => setSecondPrompt(e.target.value)}
          multiline
          rows={3}
        />
      </Grid>
      <Grid item xs={12} className="d-flex justify-content-end">
        <AppButton
          onClick={() => {
            history.push("/dmv/dashboard")
            dispatch(
              updateAvataarPromptAction({
                avatar_prompt: [firstPrompt, secondPrompt],
                avatar_enabled: isEnabled
              })
            )
          }}
          sx={{ padding: "13px 80px" }}>
          Update
        </AppButton>
      </Grid>
    </Grid>
  )
}

export default AvataarPromptManagement
